export interface UserMapFileModel {
  fileId: String,
  fileAssets?: FileAssetConfig[]
}

export interface FileAssetConfig {
  assetType: AssetType,
  color?: string
  selected: boolean
}

export enum AssetType {
  POINT = 'Points',
  LINE = 'Lines',
  POLYGON = 'Polygons',
  FILL = 'Fill',
}
